import styled from '@emotion/styled';
import { H4 } from '@triumph/design-system';
import { useTranslation } from 'react-i18next';

const AppNameWrapper = styled(H4)`
  background: ${({ theme }: any) => theme.colors.background};
  color: ${({ theme }: any) => theme.colors.greyscale.white};
`;

export const HeaderAppName = () => {
  const { t } = useTranslation('invoicesDashboard');

  return (
    <AppNameWrapper>
      <b>{t('header.debtorPortal')}</b>
    </AppNameWrapper>
  );
};
